'use strict';

// src/array-selector.ts
var withArraySelector = (storeHook) => {
  function storeHookWithArraySelector(selector, equals) {
    if (!selector) {
      return storeHook();
    }
    if (typeof selector === "function") {
      return storeHook(selector, equals);
    }
    const selectorFunction = (state) => {
      const selection = {};
      selector.forEach((key) => {
        selection[key] = state[key];
      });
      return selection;
    };
    return storeHook(
      selectorFunction,
      equals
    );
  }
  storeHookWithArraySelector.getState = storeHook.getState;
  storeHookWithArraySelector.setState = storeHook.setState;
  storeHookWithArraySelector.subscribe = storeHook.subscribe;
  storeHookWithArraySelector.destroy = storeHook.destroy;
  return storeHookWithArraySelector;
};

exports.withArraySelector = withArraySelector;
